<template>
  <div ref="whole_page" style="text-align: left;">
    <div v-if="$getSiteId() != 21" class="w-full">
      <div id="prototype" class="vx-row">
        <div class="vx-col mb-3" v-for="(_assessment, index) in assessments" :key="index" style="min-width: 260px;max-width: 260px;">
          <vx-card style="border-radius: 120px 120px 30px 30px;" class="hover_on-mouseover" @click="openAssessment(_assessment)">
            <div slot="no-body">
              <!-- <img id="card-img" src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" alt="content-img" class="responsive card-img-top" /> -->
              <div class="card-top_logo-container">
                <!-- upload -->
                <svg v-if="_assessment.taskTypeId == 6" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                <!-- video capture -->
                <svg v-if="_assessment.taskTypeId == 8" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                <!-- quiz -->
                <svg v-if="_assessment.taskTypeId == 9" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
              </div>
            </div>
            <div style="overflow: auto; height: 65px">
              <h6 class="mb-2">{{ _assessment.moduleName }}</h6>
            </div>
            <h6 class="mb-2">{{ _assessment.taskName }}</h6>
            <span class="flex mb-2" style="align-items: center;">
              <feather-icon icon="CheckIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>
              <vs-progress v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" :height="16" :percent="(_assessment.achievedMarks / _assessment.totalMarks) * 100" show-value color="success" style="text-align: start;"/>
              <p v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" class="ml-2" style="margin-top: -0.1rem !important; width:23px">
                <strong>{{ _assessment.totalMarks ? `${Math.round((_assessment.achievedMarks / _assessment.totalMarks) * 100, 2)}%` : "0%" }}</strong>
              </p>
              <div class="w-full" v-else>
                <p>
                  <strong>N/A</strong>
                </p>
              </div>
            </span>
            <span class="flex" style="align-items: center;"><feather-icon icon="ClockIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>{{ _assessment.completedDate.replace("T", " ").split('.')[0] }}</span>
            <div class="w-full mt-3" style="height: 18px;">
              <vs-chip class="w-full mt-1">{{ _assessment.statusDisplayName == 'Completed' && $getSiteId() == 21 ? 'Submitted' :_assessment.statusDisplayName}}</vs-chip>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div v-if="$getSiteId() == 21" class="w-full">
      <div id="prototype-assessments" >
        <vx-card v-if="assessments.filter(q=> q.isAssessment == true).length>0" class="glow-effect_bg-color__blend card__no-padding bg-color vx-row" style="width: 400px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_bg-color__blend bg-color">
                <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
              type="filled"
              color="">
              My Assessments
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card v-else class="glow-effect_bg-color__blend card__no-padding bg-color vx-row" style="width: 400px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_bg-color__blend bg-color">
                <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
              type="filled"
              color="">
              No Assessments
            </vs-button>
          </vx-input-group>
        </vx-card>
        <!-- Assessments -->
        <div class="vx-row">
          <div class="vx-col mb-3" v-for="(_assessment, index) in assessments.filter(q=> q.isAssessment == true)" :key="index" style="min-width: 260px;max-width: 260px;">
            <vx-card style="border-radius: 120px 120px 30px 30px;" class="hover_on-mouseover" @click="openAssessment(_assessment)">
              <div slot="no-body">
                <!-- <img id="card-img" src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" alt="content-img" class="responsive card-img-top" /> -->
                <div class="card-top_logo-container">
                  <!-- upload -->
                  <svg v-if="_assessment.taskTypeId == 6" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                  <!-- video capture -->
                  <svg v-if="_assessment.taskTypeId == 8" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                  <!-- quiz -->
                  <svg v-if="_assessment.taskTypeId == 9" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                </div>
              </div>
              <div style="overflow: auto; height: 65px">
                <h6 class="mb-2">{{ _assessment.moduleName }}</h6>
              </div>
              <h6 class="mb-2">{{ _assessment.taskName }}</h6>
              <span class="flex mb-2" style="align-items: center;">
                <feather-icon icon="CheckIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>
                <vs-progress v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" :height="16" :percent="(_assessment.achievedMarks / _assessment.totalMarks) * 100" show-value color="success" style="text-align: start;"/>
                <p v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" class="ml-2" style="margin-top: -0.1rem !important; width:23px">
                  <strong>{{ _assessment.totalMarks ? `${Math.round((_assessment.achievedMarks / _assessment.totalMarks) * 100, 2)}%` : "0%" }}</strong>
                </p>
                <div class="w-full" v-else>
                  <p>
                    <strong>N/A</strong>
                  </p>
                </div>
              </span>
              <span class="flex" style="align-items: center;"><feather-icon icon="ClockIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>{{ _assessment.completedDate.replace("T", " ").split('.')[0] }}</span>
              <div class="w-full mt-3" style="height: 18px;">
                <vs-chip class="w-full mt-1" :color="_assessment.statusDisplayName == 'Assessed' && $getSiteId() == 21 ? 'warning' : 'success'">{{ _assessment.statusDisplayName == 'Completed'?  'Submitted' : _assessment.statusDisplayName }}</vs-chip>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div id="prototype-classwork">
        <vx-card v-if="assessments.filter(q=> q.isClasswork == true).length>0" class="glow-effect_bg-color__blend card__no-padding bg-color vx-row" style="width: 400px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_bg-color__blend bg-color">
                <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
              type="filled"
              color="">
              My Classwork
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card v-else class="glow-effect_bg-color__blend card__no-padding bg-color vx-row" style="width: 400px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_bg-color__blend bg-color">
                <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
              type="filled"
              color="">
              No Classwork items
            </vs-button>
          </vx-input-group>
        </vx-card>
        <!-- Classwork Items -->
        <div class="vx-row">
          <div class="vx-col mb-3" v-for="(_assessment, index) in assessments.filter(q=> q.isClasswork == true)" :key="index" style="min-width: 260px;max-width: 260px;">
            <vx-card style="border-radius: 120px 120px 30px 30px;" class="hover_on-mouseover" @click="openAssessment(_assessment)">
              <div slot="no-body">
                <!-- <img id="card-img" src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" alt="content-img" class="responsive card-img-top" /> -->
                <div class="card-top_logo-container">
                  <!-- upload -->
                  <svg v-if="_assessment.taskTypeId == 6" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                  <!-- video capture -->
                  <svg v-if="_assessment.taskTypeId == 8" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                  <!-- quiz -->
                  <svg v-if="_assessment.taskTypeId == 9" style="color: white" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                </div>
              </div>
              <div style="overflow: auto; height: 65px">
                <h6 class="mb-2">{{ _assessment.moduleName }}</h6>
              </div>
              <h6 class="mb-2">{{ _assessment.taskName }}</h6>
              <span class="flex mb-2" style="align-items: center;">
                <feather-icon icon="CheckIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>
                <vs-progress v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" :height="16" :percent="(_assessment.achievedMarks / _assessment.totalMarks) * 100" show-value color="success" style="text-align: start;"/>
                <p v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" class="ml-2" style="margin-top: -0.1rem !important; width:23px">
                  <strong>{{ _assessment.totalMarks ? `${Math.round((_assessment.achievedMarks / _assessment.totalMarks) * 100, 2)}%` : "0%" }}</strong>
                </p>
                <div class="w-full" v-else>
                  <p>
                    <strong>N/A</strong>
                  </p>
                </div>
              </span>
              <span class="flex" style="align-items: center;"><feather-icon icon="ClockIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>{{ _assessment.completedDate.replace("T", " ").split('.')[0] }}</span>
              <div class="w-full mt-3" style="height: 18px;">
                <vs-chip class="w-full mt-1" :color="_assessment.statusDisplayName == 'Assessed' && $getSiteId() == 21 ? 'warning' : 'success'">{{ _assessment.statusDisplayName == 'Completed'?  'Submitted' : _assessment.statusDisplayName }}</vs-chip>
              </div>
            </vx-card>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select';
export default {
  components: {
    vSelect,
    VuePerfectScrollbar
  },
  data() {
    return {
      assessments: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7,
      },
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    getAssessments() {
      var self = this;
      self.showLoadingOnElement("whole_page", 1, "material");
      var onSuccess = response => {
        self.assessments = response.data;
      };
      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, "Module/GetAssessmentsForStudent?companyId=" + self.$route.query.id, onSuccess, onFinally);
    },
    openAssessment(_assessment) {
      let routeData = this.$router.resolve({ path: '/digi/viewassessment', query: { TaskLogId: _assessment.logId, viewonly: true } });
      window.open(routeData.href, '_blank');
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    self.getAssessments();
  }
};
</script>
<style lang="scss">
  #categorydropdown {
    .vs__actions {
      display: contents !important;

      .open-indicator {
        margin-right: 10px !important;
      }
    }
  }

  .card-top_logo-container {
    height: 232px;
    text-align: center;
    background-color: #262d4a;
    border-radius: 50%;
    padding-top: 55px;
    border-style: solid;
    border-width: 24px;
    border-color: #10163a;
  }
</style>
